<template>
	<v-dialog width="600px" persistent v-model="showDialog">
		<v-card>
			<v-card-text>
				<div class="list-item" v-for="(value, key) in filteredActionDetails" :key="key">
					<div>{{keyToNameMap[key] ? keyToNameMap[key] : key}}</div>
					<div>{{value}}</div>
				</div>
			</v-card-text>
			<v-layout row wrap class="justify-space-between px-2 pb-2">
				<div />
				<v-btn @click="closeModal">Close</v-btn>
			</v-layout>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: "ActionDetails",
	props: ["actionDetails", "model", "themeInputColor"],
	data() {
		return {
			showDialog: true,
			keyToNameMap: {
				transactionId: "Txn ID",
				remitterName: "Remitter Name",
				remitterBank: "Remitter Bank",
				remitterBankIfsc: "Bank IFSC Code",
				transferDate: "Transfer Date",
				createdOn: "Created On",
				amount: "Amount",
				approverName: "Approver Name",
				status: "Status",
				userId: "Distributor ID"
			},
			hideKeys: ["approverId", "updatedOn"]
		};
	},
	methods: {
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		}
	},
	computed: {
		filteredActionDetails: function() {
			const newObj = {};
			Object.keys(this.actionDetails).forEach(key => {
				if (this.hideKeys.indexOf(key) == -1) {
					newObj[key] = this.actionDetails[key];
				}
			});
			return newObj;
		}
	}
};
</script>
<style scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 5px;
	border-bottom: 1px solid #ccc;
}
</style>